/* eslint-disable react/prop-types */
import React from "react";

import styles from "./blueprint-dashboard.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import {
  BlueprintDashboardObj,
  useBlueprintDashboardHook,
} from "./use-blueprint-dashboard-hook";
import { DashboardPanel } from "@src/components/organisms/dashboard-panel/dashboard-panel";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { EnableDisableAllBlueprintDashboardToggles } from "../enable-disable-all-blueprint-dashboard-toggles/enable-disable-all-blueprint-dashboard-toggles";

interface BlueprintDashboardProps {
  useHook?: () => BlueprintDashboardObj;
}

const cssClassName = "blueprint-dashboard";

export const BlueprintDashboard = ({
  useHook = useBlueprintDashboardHook,
}: BlueprintDashboardProps) => {
  const group_id = useSelector(
    (state: RootState) => state.yourSlice.connectionView.source.source_id,
  );

  const { tiles } = useHook();

  return (
    <>
      <div className={styles[cssClassName]}>
        {tiles &&
          tiles.map((tile) => (
            <DashboardPanel key={tile.getId()} groupId={group_id} tile={tile} />
          ))}
      </div>
      <Spacer16 />
      <EnableDisableAllBlueprintDashboardToggles />
    </>
  );
};
